import { createRoot } from 'react-dom/client';
import React from 'react';
import axios from 'axios';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { ThemeProvider } from '@dsi/react-eds';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import App from './App';
import AppDummy from './AppDummy';
import '@eds/vanilla/eds.min.css';
import reportWebVitals from './reportWebVitals';
import { UserDataProvider } from './Context/UserDataContext';
import { SiteDataProvider } from './Context/SiteDataContext';
import { RegionDataProvider } from './Context/RegionDataContext';
import { MapDataProvider } from './Context/MapDataContext';
import { CustomerDataProvider } from './Context/CustomerDataContext';
import { ApplicationDataProvider } from './Context/ApplicationDataContext';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import configureStore from './store/configureStore';
import { history } from './utils';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import { MsalProvider } from '@azure/msal-react';
import { loginRequest } from './utils/authConfig';
import { msalInstance } from './utils/msalInstance';
import GlobalLoader from './utils/globalLoader';

/**
 * Create Redux Store
 */
export const store = configureStore({}, history);
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false
    }
  }
});

axios.interceptors.request.use(async (reqConf) => {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    const accessTokenRequest = {
      scopes: ["user.read"], 
      account: accounts[0],
    };
    try {
      const accessTokenResponse = await msalInstance.acquireTokenSilent(accessTokenRequest);
      reqConf.headers = {
        ...reqConf.headers,
        Authorization: `Bearer ${accessTokenResponse.idToken}`,
      };
    } catch (error) {
      console.error('Token acquisition failed:', error);
    }
  }
  return reqConf;
});

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status;
     if ((status === 401 || status === 403) && (error?.response?.data?.error == "Token expired" || error?.response?.data?.error == "Missing or invalid Authorization header")) {
       await msalInstance.logoutRedirect(); 
    }
    return Promise.reject(error);
  }
);

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

msalInstance.initialize().then(() => {
  msalInstance.handleRedirectPromise().then((response) => {
    if (response) {
      msalInstance.setActiveAccount(response.account);
    } else {
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length === 0) {
        msalInstance.loginRedirect({ ...loginRequest, prompt: 'create' });
        return;
      } else {
        msalInstance.setActiveAccount(accounts[0]);
      }
    }

    root.render(
        <MsalProvider instance={msalInstance}>
          <Provider store={store}>
            {/* <ConnectedRouter history={history}> */}
            <HashRouter>
              <ThemeProvider useSystemTheme>
                <QueryClientProvider client={queryClient}>
                  <GlobalLoader />
                  <ApplicationDataProvider>
                    <UserDataProvider>
                      <CustomerDataProvider>
                        <MapDataProvider>
                          <RegionDataProvider>
                            <SiteDataProvider>
                              <App />
                            </SiteDataProvider>
                          </RegionDataProvider>
                        </MapDataProvider>
                      </CustomerDataProvider>
                    </UserDataProvider>
                  </ApplicationDataProvider>
                  <ReactQueryDevtools initialIsOpen={false} position={'bottom-right'} />
                </QueryClientProvider>
              </ThemeProvider>
            </HashRouter>
          </Provider>
        </MsalProvider>
    );
  }).catch((error) => {
    console.error("MSAL error:", error);
  });
});

// ReactDOM.render(
//   <HashRouter>
//     <ThemeProvider useSystemTheme>
//       <App />
//       {/* <AppDummy /> */}
//     </ThemeProvider>
//   </HashRouter>,
//   document.getElementById('root'),
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();